// extracted by mini-css-extract-plugin
export default {"HashtagCounter":"HashtagCounter_HashtagCounter__PSfK5","OffLimit":"HashtagCounter_OffLimit__d210F"};